// Central content store for Rudrash Private Limited
export const COMPANY = {
  name: "Rudrash Private Limited",
  short: "Rudrash",
  tagline: "Pioneering Sustainable Agriculture in Eastern India",
  cin: "U01136WR2026PTC292711",
  address:
    "Sinha Bhavan Parbaganj, Nangl Bayanagar LP-205, Kolkata – 700141, West Bengal, India",
  addressShort: "Sinha Bhavan Parbaganj, Nangl Bayanagar LP-205, Kolkata – 700141, West Bengal",
  phone: "+91 90070 55358 ",
  phone2: "+91 91635 33727",
  phoneHref: "tel:+919007055358 ",
  phoneHref2: "tel:+919163533727",
  email: "rudrashpvtltd@gmail.com",
  founded: "2026",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Products",
    to: "/products",
    children: [
      { label: "Mushroom", to: "/mushroom" },
      { label: "Saffron", to: "/saffron" },
      { label: "Poultry", to: "/poultry" },
    ],
  },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
  { label: "Certifications", to: "/certifications" },
];

export const HERO_SLIDES = [
  {
    id: "saffron",
    eyebrow: "Vertical 01 — Premium",
    title: "Saffron Cultivation",
    intro:
      "Pure saffron. Precision grown.",
    cta: "Discover More",
    ctaTo: "/saffron",
    image: "/images/saffron-hero.avif",
  },
  {
    id: "mushroom",
    eyebrow: "Vertical 02 — Gourmet",
    title: "Mushroom Farming",
    intro:
      "Exotic mushrooms. Climate controlled.",
    cta: "Discover More",
    ctaTo: "/mushroom",
    image: "/images/mushroom-hero.avif",
  },
  {
    id: "poultry",
    eyebrow: "Vertical 03 — Ethical",
    title: "Poultry Operations",
    intro:
      "Free-range poultry. Ethically raised.",
    cta: "Discover More",
    ctaTo: "/poultry",
    image: "/images/poultry-hero.avif",
  },
];

export const FEATURES = [
  {
    icon: "Sprout",
    title: "Advanced Soilless Farming",
    text: "Aeroponic and hydroponic systems engineered for density, cleanliness, and precision nutrient delivery.",
  },
  {
    icon: "Leaf",
    title: "Organic, Chemical-Free Produce",
    text: "Premium output grown without pesticides — fresh, nutrient-dense and traceable from rack to retailer.",
  },
  {
    icon: "Recycle",
    title: "Sustainable High-Yield Cultivation",
    text: "Up to 90% less water usage, climate-independent production, optimized for India's eastern markets.",
  },
];

export const PRODUCTS = [
  {
    id: "mushroom",
    title: "Mushroom",
    tagline: "Exotic & Gourmet Varieties",
    slug: "/mushroom",
    image:
      "https://images.unsplash.com/photo-1726177972645-27a8cf78abcb?q=80&w=627&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?auto=format&fit=crop&w=1200&q=80",
    short:
      "Oyster and shiitake mushrooms cultivated in controlled-environment facilities for year-round, premium output.",
    highlights: ["Year-round production", "Gourmet varieties", "Climate-controlled", "No pesticides"],
    description:
      "Rudrash produces premium exotic varieties — including oyster and shiitake mushrooms — using aeroponic and substrate-based methods in climate-controlled facilities. Our year-round output ensures consistent quality with minimal resource waste.",
    heroImage:
      "https://images.unsplash.com/photo-1611250188496-e966043a0629?auto=format&fit=crop&w=1800&q=80",
    gallery: [
      "https://images.pexels.com/photos/2478418/pexels-photo-2478418.jpeg?auto=format&fit=crop&w=900&q=80",
      "https://images.pexels.com/photos/2478421/pexels-photo-2478421.jpeg?auto=compress&cs=tinysrgb&w=900",
      "https://images.pexels.com/photos/16732697/pexels-photo-16732697.jpeg?auto=format&fit=crop&w=900&q=80",
      "https://images.pexels.com/photos/8827284/pexels-photo-8827284.jpeg?auto=format&fit=crop&w=900&q=80",
    ],
  },
  {
    id: "saffron",
    title: "Saffron",
    tagline: "Grown Without Soil, Without Limits",
    slug: "/saffron",
    image:
      "https://images.unsplash.com/photo-1656569125771-f70104a363ac?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    short:
      "High-value saffron crocus raised with aeroponics and hydroponics — premium stigmas with exceptional aroma and color.",
    highlights: ["Aeroponic / hydroponic", "Urban setup", "Premium grade", "Climate-independent"],
    description:
      "We employ aeroponics and hydroponics to cultivate high-value saffron crocus in urban setups, bypassing traditional soil and climate barriers. The result: cost-effective, premium red stigmas with exceptional aroma and colour.",
    heroImage:
      "https://images.unsplash.com/photo-1599940824399-b87987ceb72a?auto=format&fit=crop&w=1800&q=80",
    gallery: [
      "https://images.pexels.com/photos/35395718/pexels-photo-35395718.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=900",
      "https://images.pexels.com/photos/19029714/pexels-photo-19029714.jpeg?auto=format&fit=crop&w=900&q=80",
      "https://images.unsplash.com/photo-1643471672168-f4a4b6cfa440?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?auto=compress&cs=tinysrgb&w=900",
      "https://images.pexels.com/photos/36702856/pexels-photo-36702856.jpeg?auto=format&fit=crop&w=900&q=80",
    ],
  },
  {
    id: "poultry",
    title: "Poultry",
    tagline: "Free-Range & Organic Operations",
    slug: "/poultry",
    image:
      "/images/poultry.webp",
    short:
      "Free-range, ethically raised birds supported by modern biosecurity and feed-optimization protocols.",
    highlights: ["Free-range", "Biosecurity standards", "Eggs & meat", "Integrated farming"],
    description:
      "Rudrash raises free-range and organic poultry for eggs and meat, integrating modern biosecurity practices and feed optimization. Our integrated farming model ensures healthy, ethically raised birds and top-quality produce.",
    heroImage:
      "https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?auto=format&fit=crop&w=1800&q=80",
    gallery: [
      "https://images.pexels.com/photos/35877058/pexels-photo-35877058.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=900",
      "https://images.pexels.com/photos/30893349/pexels-photo-30893349.jpeg?auto=compress&cs=tinysrgb&w=900",
      "https://images.pexels.com/photos/27083552/pexels-photo-27083552.jpeg?auto=compress&cs=tinysrgb&w=900",
      "https://images.pexels.com/photos/2253583/pexels-photo-2253583.jpeg?auto=format&fit=crop&w=900&q=80",
    ],
  },
];

export const STATS = [
  { value: 150, suffix: "+", label: "Agriculture Products" },
  { value: 4500, suffix: "+", label: "Projects Completed" },
  { value: 6000, suffix: "+", label: "Satisfied Clients" },
  { value: 1300, suffix: "+", label: "Expert Farmers" },
];

export const WHY_CHOOSE = [
  {
    icon: "Droplets",
    title: "Integrated Farming & Processing",
    text: "From cultivation to packaging and distribution, every stage is managed within a controlled system — ensuring consistency, traceability, and quality across all products.",
  },
  {
    icon: "Sparkles",
    title: "Certified Quality Standards",
    text: "Operating under structured quality management practices aligned with ISO 9001:2015 standards, ensuring reliable processes, product consistency, and operational excellence.",
  },
  {
    icon: "Cpu",
    title: "Multi-Crop & Scalable Operations",
    text: "Expertise across mushrooms, saffron, medicinal plants, herbs, and poultry — built on systems designed to scale efficiently without compromising quality.",
  },
  {
    icon: "Globe2",
    title: "Market-Ready Supply Chain",
    text: "Focused on delivering to local markets, businesses, and export channels with reliable supply, consistent quality, and long-term partnerships.",
  },
];

export const MVV = [
  {
    label: "Mission",
    title: "Build a complete farm-to-market ecosystem.",
    body: "To cultivate, process, and deliver high-quality agricultural produce using eco-friendly, chemical-free methods — ensuring consistency, efficiency, and trust across every stage of the value chain.",
  },
  {
    label: "Vision",
    title: "leading integrated agri-enterprise globally",
    body: "To scale sustainable farming through controlled environments, modern infrastructure, and strong distribution networks — making premium produce accessible across local and global markets.",
  },
  {
    label: "Core Values",
    title: "What drives every harvest.",
    body: "Quality assurance, sustainability, operational discipline, and long-term partnerships — ensuring every product meets high standards from cultivation to customer delivery.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The quality of Rudrash oyster mushrooms transformed our seasonal menu. Consistency, shelf life, and flavour are simply unmatched in the region.",
    name: "Arjun Banerjee",
    role: "Executive Chef, Calcutta Grain House",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&h=500&fit=crop",
  },
  {
    quote:
      "I have sourced saffron for years. The aroma and colour of Rudrash stigmas rival the best Kashmiri lots we've imported — and it's grown locally.",
    name: "Ritika Sengupta",
    role: "Founder, Spice Atelier Kolkata",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=500&h=500&fit=crop",
  },
  {
    quote:
      "Their biosecurity and free-range practices set a new benchmark for the eastern poultry supply. Ethical, clean, and traceable.",
    name: "Dr. Subir Ghosh",
    role: "Veterinary Consultant, Bengal Livestock Forum",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=500&h=500&fit=crop",
  },
];

export const BLOG_POSTS = [
  {
    slug: "future-of-urban-farming-eastern-india",
    title: "The Future of Urban Farming in Eastern India",
    date: "2026-01-14",
    category: "Insights",
    excerpt:
      "How controlled-environment agriculture is quietly reshaping food supply across Kolkata and the eastern states — from rooftops to warehouses.",
    image:
      "https://images.pexels.com/photos/20075896/pexels-photo-20075896.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "aeroponics-revolutionizing-saffron",
    title: "How Aeroponics Is Revolutionizing Saffron Cultivation",
    date: "2026-01-28",
    category: "Science",
    excerpt:
      "Aeroponic saffron breaks every traditional constraint — geography, season, and soil. Here is why it's the most exciting crop of the decade.",
    image:
      "https://plus.unsplash.com/premium_photo-1734554230099-3d596f35fd93?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "organic-mushrooms-restaurant-menus",
    title: "Why Organic Mushrooms Are Taking Over Restaurant Menus",
    date: "2026-02-06",
    category: "Trends",
    excerpt:
      "Chefs across India are ditching imported commodity mushrooms for exotic, locally grown varieties. The reasons go beyond taste.",
    image:
      "https://images.unsplash.com/photo-1611250188496-e966043a0629?auto=format&fit=crop&w=1200&q=80",
  },
];

export const TEAM = [
  {
    name: "Sudip Kar",
    role: "Director & Co-Founder",
    avatar: "/images/founder.webp",
  },
  {
    name: "Mrinmoy Bhandari",
    role: "Director & Co-Founder",
    avatar: "/images/director.jpeg",
  },
];

export const CERTIFICATIONS = [
  {
    id: "iso-9001",
    title: "ISO 9001:2015 Certification",
    shortDesc: "International standard for Quality Management Systems.",
    longDesc: "This certification validates our rigorous quality assurance processes across our entire cultivation and distribution operations, ensuring consistent and sustainable deliverables.",
    icon: "ShieldCheck",
    highlight: true,
    pdfUrl: "/certifications/iso.pdf",
    previewUrl: "/certifications/iso.webp",
  },
  {
    id: "incorporation",
    title: "Certificate of Incorporation",
    shortDesc: "Officially registered entity under the Ministry of Corporate Affairs.",
    longDesc: "Validates our formal registration and standing as an incorporated Private Limited company within India, affirming corporate legitimacy.",
    icon: "FileText",
    pdfUrl: "/certifications/incorporationCert.pdf",
    previewUrl: "/certifications/incorporationCert.webp",
  },
  {
    id: "udyam",
    title: "Udyam Registration",
    shortDesc: "Recognized micro, small, and medium enterprise (MSME).",
    longDesc: "Registered under the Ministry of MSME, underscoring our contribution to the local economy and operational transparency.",
    icon: "Briefcase",
    pdfUrl: "/certifications/UdyamRegistrationCert.pdf",
    previewUrl: "/certifications/UdyamRegistrationCert.webp",
  },
  {
    id: "startup-india",
    title: "Startup Recognition (DPIIT)",
    shortDesc: "Recognized by the Department for Promotion of Industry and Internal Trade.",
    longDesc: "Acknowledged for bringing technological innovation and sustainable business practices to the agricultural sector.",
    icon: "Rocket",
    pdfUrl: "/certifications/dpiit.pdf",
    previewUrl: "/certifications/dpiit.webp",
  },
];
